import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LayoutService } from 'src/app/services/layout.service';
import { MobileBreakpointService } from 'src/app/services/mobile-breakpoint.service';
import { SidenavService } from 'src/app/services/sidenav.service';
import { InitialsAvatarUtil } from 'src/app/utils/initial-avatar';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  header?: { title: string; subtitle: string; locationBack?: string };
  avatar: string = '';
  userName: string = '';
  isMobile: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private sidenavService: SidenavService,
    private layoutService: LayoutService,
    private router: Router,
    private cdref: ChangeDetectorRef,
    private mobileBreakpointService: MobileBreakpointService
  ) {
    this.handleGetCurrentUser();
    this.isMobile = this.mobileBreakpointService.isMobile();
  }

  ngOnInit(): void {
    this.checkIfIsMobile();
  }

  ngAfterViewInit(): void {
    this.setHeader();
  }

  private checkIfIsMobile(): void {
    this.mobileBreakpointService.isMobile$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isMobile) => {
        this.isMobile = isMobile;
      });
  }

  private handleGetCurrentUser(): void {
    this.authService.user$
      .pipe(
        tap((user) => {
          this.userName = user?.fullName || 'Usuário';
          this.avatar = InitialsAvatarUtil.Do(this.userName);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  private setHeader(): void {
    this.layoutService.header
      .pipe(takeUntil(this.destroy$))
      .subscribe((header) => {
        this.header = header;
        this.cdref.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleSidenav(): void {
    this.sidenavService.toggle();
  }

  logout(): void {
    this.authService.logout();
  }

  changePassword(): void {
    this.router.navigate(['/redefinir_senha']);
  }

  goToServiceDesk(): void {
    window.open(
      'https://teambroadfactor.atlassian.net/servicedesk/customer/portals',
      '_blank'
    );
  }

  goBack(): void {
    if (this.header?.locationBack) {
      this.router.navigate([this.header.locationBack]);
    }
  }
}
